<div class="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-md animate-fade-in"
    (click)="onCancel()">

    <div class="bg-white dark:bg-slate-800 w-full max-w-4xl max-h-[90vh] rounded-[2.5rem] shadow-[0_20px_100px_rgba(0,0,0,0.2)] flex flex-col  animate-fade-in-up relative z-[100]"
        (click)="$event.stopPropagation(); openDropdown = null">

        <!-- Header -->
        <div
            class="px-8 py-6 border-b border-slate-100 dark:border-slate-700 flex items-center justify-between bg-white/50 dark:bg-slate-800/50 backdrop-blur-xl rounded-t-[2.5rem]  sticky top-0 z-20">
            <div class="flex items-center gap-4">
                <div
                    class="w-12 h-12 rounded-2xl bg-amber-50 dark:bg-amber-900/30 flex items-center justify-center text-amber-500">
                    <span class="material-icons text-2xl">price_check</span>
                </div>
                <div>
                    <h2 class="text-xl font-black text-slate-800 dark:text-slate-100 tracking-tight">
                        {{ fineData ? 'แก้ไขประเภทค่าปรับ' : 'เพิ่มประเภทค่าปรับใหม่' }} / {{ fineData ? 'Edit' : 'New'
                        }}
                    </h2>
                    <p
                        class="text-[10px] font-black text-slate-400 dark:text-slate-500 uppercase tracking-widest mt-0.5">
                        Fine Type Information / Revenue Code</p>
                </div>
            </div>

            <div class="flex items-center gap-3">
                <button (click)="onCancel()"
                    class="px-6 py-2.5 rounded-xl text-slate-500 dark:text-slate-400 font-bold hover:bg-slate-100 dark:hover:bg-slate-700 transition-all text-xs uppercase tracking-widest">ยกเลิก</button>
                <button (click)="onSave()" [disabled]="isLoading"
                    class="px-8 py-2.5 bg-amber-400 hover:bg-amber-500 text-white font-black rounded-xl shadow-lg shadow-amber-200 dark:shadow-none hover:-translate-y-0.5 transition-all flex items-center gap-2 text-xs uppercase tracking-widest">
                    <span *ngIf="isLoading"
                        class="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></span>
                    บันทึก
                </button>
            </div>
        </div>

        <!-- Form Area (2-Column Grid to match screenshot) -->
        <div class="flex-1 p-12 custom-scrollbar relative z-[110]">
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-x-16 gap-y-8">

                <!-- Left Section -->
                <div class="space-y-6">
                    <!-- ชื่อค่าปรับ -->
                    <div class="grid grid-cols-3 items-center gap-4">
                        <label class="text-xs font-black text-slate-700 dark:text-slate-300">ชื่อค่าปรับ</label>
                        <div class="col-span-2">
                            <input type="text" [(ngModel)]="form.name" placeholder="ชื่อค่าปรับ"
                                class="w-full h-11 px-4 bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-800 rounded-xl text-sm font-bold focus:bg-white focus:ring-4 focus:ring-amber-50 transition-all outline-none">
                        </div>
                    </div>

                    <!-- Fine (Amount) -->
                    <div class="grid grid-cols-3 items-center gap-4">
                        <label class="text-xs font-black text-slate-700 dark:text-slate-300">จำนวนเงิน</label>
                        <div class="col-span-2 relative">
                            <input type="number" [(ngModel)]="form.amount"
                                class="w-full h-11 px-4 bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-800 rounded-xl text-sm font-bold outline-none font-mono">
                            <span
                                class="absolute right-4 top-1/2 -translate-y-1/2 text-[10px] font-black text-slate-400">THB</span>
                        </div>
                    </div>

                    <!-- Vat Included -->
                    <div class="grid grid-cols-3 items-center gap-4">
                        <label class="text-xs font-black text-slate-700 dark:text-slate-300">รวมภาษี</label>
                        <div class="col-span-2 flex items-center">
                            <div (click)="form.isVatIncluded = !form.isVatIncluded"
                                class="w-6 h-6 rounded-lg flex items-center justify-center transition-all border cursor-pointer"
                                [ngClass]="form.isVatIncluded ? 'bg-emerald-500 border-emerald-500 text-white shadow-lg' : 'bg-white dark:bg-slate-900 border-slate-200 text-transparent'">
                                <span class="material-icons text-sm font-black">check</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Right Section -->
                <div class="space-y-6 relative z-[120]">
                    <!-- รายได้ (Revenue) Dropdown -->
                    <div class="grid grid-cols-3 items-center gap-4">
                        <label class="text-xs font-black text-slate-700 dark:text-slate-300">รายได้</label>
                        <div class="col-span-2 relative">
                            <button (click)="toggleDropdown('revenueSelect', $event)"
                                class="w-full h-11 px-4 bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-800 rounded-xl flex items-center justify-between text-sm font-bold">
                                <span [class.text-slate-400]="!form.revenueName">{{ form.revenueName ||
                                    'เลือกประเภทรายได้' }}</span>
                                <span class="material-icons text-slate-400 text-sm">expand_more</span>
                            </button>
                            <div *ngIf="openDropdown === 'revenueSelect'"
                                class="absolute top-full left-0 right-0 mt-2 z-[130] bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 py-2 animate-fade-in-up">
                                <div *ngFor="let r of revenueOptions" (click)="selectOption('revenueName', r)"
                                    class="px-4 py-2.5 text-sm font-bold hover:bg-amber-50 dark:hover:bg-slate-700 hover:text-amber-600 cursor-pointer transition-all">
                                    {{ r }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Site Dropdown -->
                    <div class="grid grid-cols-3 items-center gap-4">
                        <label class="text-xs font-black text-slate-700 dark:text-slate-300">พื้นที่บริการ</label>
                        <div class="col-span-2 relative">
                            <button (click)="toggleDropdown('siteSelect', $event)"
                                class="w-full h-11 px-4 bg-amber-50/80 dark:bg-slate-900 border border-amber-100/50 dark:border-slate-800 rounded-xl flex items-center justify-between text-sm font-black text-amber-600">
                                <span class="truncate" [class.text-amber-600]="!form.site">{{ form.site ||
                                    'เลือกพื้นที่' }}</span>
                                <span class="material-icons text-amber-600 text-sm">expand_more</span>
                            </button>
                            <div *ngIf="openDropdown === 'siteSelect'"
                                class="absolute top-full left-0 right-0 mt-2 z-[130] bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 py-2 max-h-[200px] overflow-y-auto animate-fade-in-up">
                                <div *ngFor="let s of siteList?.data" (click)="selectOption('site', s.name)"
                                    class="px-4 py-2.5 text-sm font-bold hover:bg-amber-50 dark:hover:bg-slate-700 hover:text-amber-600 transition-all cursor-pointer">
                                    {{ s.name }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>